import React, { useState } from "react";
import {
  ArrowLeft,
  AlertTriangle,
  CheckCircle
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function Report() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderId = params.get("order");

  const student = JSON.parse(localStorage.getItem("student") || "{}");

  const [issueType, setIssueType] = useState("");
  const [description, setDescription] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const ISSUES = [
    "Missing Clothes",
    "Wrong Clothes Returned",
    "Damaged Clothes",
    "Delay in Delivery",
    "Received Someone Else's Clothes",
    "Not Washed Properly",
    "Other",
  ];

  const handleSubmit = async () => {
    if (!issueType) return alert("Please select an issue type");
    if (!description.trim()) return alert("Please describe the issue");

    const res = await fetch("https://hostel-laundry-api.onrender.com/issues/new",
 {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        usn: student.usn,
        orderId,
        issueType,
        description,
      }),
    });

    const data = await res.json();
    if (data.success) {
      setSubmitted(true);
    } else {
      alert("Failed to submit issue");
    }
  };

  // SUCCESS SCREEN
  if (submitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white p-6 text-center">
        <CheckCircle className="w-16 h-16 text-neutral-900 mb-4" />
        <h1 className="text-2xl font-semibold text-neutral-900">
          Issue Submitted
        </h1>
        <p className="text-neutral-500 text-sm mt-1">
          We will look into it shortly.
        </p>

        <button
          onClick={() => (window.location.href = "/student-dashboard")}
          className="mt-6 bg-neutral-900 text-white px-6 py-3 rounded-xl font-medium text-sm hover:bg-neutral-800 transition shadow-sm"
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white p-4 flex justify-center">
      <div className="w-full max-w-3xl space-y-5">

        {/* HEADER */}
        <header className="flex items-center justify-between bg-white/80 backdrop-blur-lg border border-neutral-200 rounded-xl px-4 py-3">
          <Link
            to="/track-order"
            className="p-2 rounded-full hover:bg-neutral-100 transition"
          >
            <ArrowLeft className="w-5 h-5 text-neutral-700" />
          </Link>

          <h1 className="text-base font-semibold text-neutral-900">
            Report Issue
          </h1>

          <div className="w-5" />
        </header>

        {/* CARD */}
        <div className="bg-white border border-neutral-200 rounded-2xl p-6">

          {/* Title */}
          <div className="flex items-center gap-3 mb-4">
            <AlertTriangle className="w-7 h-7 text-neutral-900" />
            <h2 className="text-lg font-semibold text-neutral-900">
              What went wrong?
            </h2>
          </div>

          {/* ISSUE OPTIONS */}
          <div className="grid grid-cols-1 gap-2.5 mt-4">
            {ISSUES.map((item, idx) => (
              <button
                key={idx}
                onClick={() => setIssueType(item)}
                className={`p-3 rounded-xl border text-left text-sm font-medium transition ${
                  issueType === item
                    ? "border-neutral-900 bg-neutral-900 text-white"
                    : "border-neutral-200 bg-neutral-50 hover:bg-neutral-100 hover:border-neutral-300 text-neutral-700"
                }`}
              >
                {item}
              </button>
            ))}
          </div>

          {/* DESCRIPTION */}
          <div className="mt-5">
            <label className="text-sm font-medium text-neutral-700">
              Describe the issue
            </label>

            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Give a short explanation..."
              className="w-full mt-2 min-h-[100px] p-3 rounded-xl border border-neutral-200 bg-neutral-50 text-neutral-900 text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900 focus:bg-white transition-all"
            ></textarea>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            onClick={handleSubmit}
            className="w-full bg-neutral-900 text-white mt-5 py-3.5 rounded-xl font-semibold text-sm hover:bg-neutral-800 transition shadow-sm"
          >
            Submit Issue
          </button>
        </div>
      </div>
    </div>
  );
}
